module.exports = __webpack_public_path__ + "img/icon_service.d5770195.svg";